import styled from 'styled-components'

import { InputUI } from '@fourthwall/components'

export const ErrorMessage = styled(InputUI.Error)`
  width: 200px;
`
